import ApiService from 'app/services/ApiService';

export const CLIENT_REPORT_BEGIN = 'CLIENT_REPORT_BEGIN';
export const CLIENT_REPORT_SUCCESS = 'CLIENT_REPORT_SUCCESS';
export const CLIENT_REPORT_FAILURE = 'CLIENT_REPORT_FAILURE';

export function fetchClientReport(data, id) {
    return async dispatch => {
        dispatch(clientReportBegin());
        await ApiService.getClientReports(data, id)
            .then(
                result => {
                    dispatch(clientReportAdd(result));
                },
                error => {
                    dispatch(clientReportError());
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export const clientReportBegin = () => ({
    type: CLIENT_REPORT_BEGIN,
});

export const clientReportAdd = data => ({
    type: CLIENT_REPORT_SUCCESS,
    payload: { data }
})

export const clientReportError = () => ({
    type: CLIENT_REPORT_FAILURE,
})
